import React from "react";
import { message, Popconfirm } from "antd";
import { gql, useMutation } from "@apollo/client";

const DELETEUSER = gql`
  mutation removeUser($id: ID!) {
    removeUser(id: $id)
  }
`;

function DeleteUser({ id, name, children, onDeleteUser }) {
  const [runDeleteUser, deleteUser] = useMutation(DELETEUSER, {
    onCompleted({ removeUser }) {
      if (removeUser) {
        message.success(`کاربر ${name ? name : ""} حذف شد.`);
        onDeleteUser();
      }
    },
    onError(err) {
      message.error(err.message);
    },
  });
  const doDeleteUser = () => {
    runDeleteUser({
      variables: { id },
    });
  };
  return (
    <>
      <Popconfirm
        title={`حذف ${name ? name : "کاربر"}?`}
        okText="حذف"
        cancelText="خیر"
        onConfirm={doDeleteUser}
      >
        <span>{children}</span>
      </Popconfirm>
    </>
  );
}

export default DeleteUser;
